import * as React from "react";
// import Appartements from "./components/Appartement/Appartements";
// import Villas from "./components/Villa/Villas";
// import Home from "./Home";
import DataWebsite from "./components/DataWebsite";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";

// import {
//   FirebaseDataProvider,
//   FirebaseAuthProvider
// } from "react-admin-firebase";

// import { firebaseConfig as config } from './FIREBASE_CONFIG';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

import {
  FirebaseAuthProvider,
  IfFirebaseUnAuthed,
  IfFirebaseAuthed,
  FirebaseAuthConsumer,
  IfFirebaseAuthedAnd
} from "react-firebase-auth-provider";
import { firebaseConfig as config } from './config/FIREBASE_CONFIG';

import CustomLoginPage from "./components/CustomLoginPagev2";
import Home from "./Home";
import CarteDesPrix from "./CDP/CarteDesPrix";
import AddPA from "./CDP/AddPA";
import ReplacePA from "./CDP/ReplacePA";

// import { LeadsCreate } from "./Leads";

// const options = {};
// const dataProvider = FirebaseDataProvider(config, options);
// const authProvider = FirebaseAuthProvider(config, options);

// const myAuthProvider = {
//   ...authProvider,
//   login: async (params) => {
//     const user = await authProvider.login(params);
//     const claims = await authProvider.getPermissions();
//     console.log(claims)
//     const isAdmin = claims.admin === true;
//     if (isAdmin) {
//       return user;
//     }
//     await authProvider.logout()
//     throw new Error('Login error, invalid permissions');
//   },
// }

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: false
    }
  }
  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {


      if (user) {

        user.getIdTokenResult().then(token => {


          if (token.claims.admin) {
            this.setState({ loggedIn: true })
            localStorage.setItem("auth", token.token)
          }
          else {
            this.setState({ loggedIn: false })
          }
        })

      } else {
        this.setState({ loggedIn: false })
      }
    })
  }
  render() {
    console.log("rendering");
    return (
      <FirebaseAuthProvider {...config} firebase={firebase}>
        {!this.state.loggedIn ? (
          <CustomLoginPage />
        ) : (
          <IfFirebaseAuthed>
            <Router>
              <Switch>
                {/* <Route exact path="/appartements" component={Appartements} /> */}
                {/* <Route exact path="/villas" component={Villas} /> */}
                {/* <Route component={Home} /> */}
                <Route path="/replace/pas/:id" component={ReplacePA} />
                <Route path="/add/pas/:id" component={AddPA} />
                <Route exact path="/cdp" component={CarteDesPrix} />
                <Route exact path="/valuation" component={DataWebsite} />
                <Route component={Home} />
              </Switch>
            </Router>
          </IfFirebaseAuthed>
        )}
      </FirebaseAuthProvider>

    );
  }
}

export default App;
